<template>
    <b-row class="justify-content-center">
        <b-col>
            <b-card>
                <div class="text-center">
                    <i class="fa fa-spinner fa-spin fa-3x fa-fw"></i>
                    <p v-text="this.message" />
                </div>
            </b-card>
        </b-col>
    </b-row>
</template>

<script>
export default {
  props: {
    'message': {
      default() {
        return 'Loading Results...';
      }
    },
  },
}
</script>

<style scoped>
    i {
        color: #00aeef;
    }
</style>
